<template>
    <el-container class="layout">
        <el-header>
            <Header />
        </el-header>
        <el-container>
            <el-aside width="210px">
                <el-menu
                    :default-active="defaultActive"
                    class="el-menu-vertical-demo"
                    background-color="#333"
                    text-color="#fff"
                    active-text-color="#ffd04b"
                    @select="handleSelect"
                >
                    <NavMenu :navMenus="menuData" />
                </el-menu>
            </el-aside>
            <el-main>
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item>
                        <a href="/">首页</a>
                    </el-breadcrumb-item>
                    <el-breadcrumb-item>
                        <a href="/manager">管理平台</a>
                    </el-breadcrumb-item>
                    <el-breadcrumb-item v-for="item in menu" :key="item.id">
                        {{ item.alias }}
                    </el-breadcrumb-item>
                </el-breadcrumb>
                <br />
                <router-view />
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import NavMenu from "@/components/NavMenu";
import Header from "@/components/Header";

import { getMenuList } from "@/api/views/manager";

export default {
    components: {
        NavMenu,
        Header
    },
    data() {
        return {
            // 面包屑列表
            menu: [],
            // 菜单列表
            menuData: [],
            // 默认项
            defaultActive: ""
        };
    },
    watch: {
        // 监听路由更新面包屑
        "$store.state.routerList": function(val) {
            let path = JSON.parse(JSON.stringify(val));
            path.shift();
            path.shift();
            // 修改面包屑
            this.setMenu(path);
        }
    },
    created() {
        // 获取菜单列表
        getMenuList().then(res => {
            let level = 1;
            if (JSON.stringify(this.$store.state.userInfo) != "{}") {
                 var levelstr=this.$store.state.userInfo.islogin+'';
                level = levelstr.split("")[0];
            }
            res.data.forEach(item => {
               
                if (item.path == "/manager/admin") {
                    if (level > 2) {
                        this.menuData.push(item);
                    }
                }else if (item.path == "/manager/webNewsList") {
                    if (level > 2) {
                        this.menuData.push(item);
                    }
                }else if (item.path == "/manager/webNoticeList") {
                    if (level > 2) {
                        this.menuData.push(item);
                    }
                }
                 else {
                    this.menuData.push(item);
                }
            });
                console.log(this.$route.path);
            // 设置默认面包屑
            const path = this.$route.path.split("/");
            path.shift();
            path.shift();
            this.setMenu(path);

            // 设置默认项
            this.defaultActive = path.pop();
        });
    },
    methods: {
        // 设置menu面包屑
        setMenu(list) {
            let tree = this.menuData;
            this.menu = [];
            // 遍历被点击的菜单的路径
            list.forEach(item => {
                // 遍历菜单列表
                tree.forEach(treeItem => {
                    // 找到对应菜单
                    if (item == treeItem.path) {
                        // 将对应菜单节点信息添加到列表中
                        this.menu.push(treeItem);
                        // 加深一层树
                        tree = treeItem.childs;
                    }
                });
            });
        },
        // 处理菜单点击事件
        handleSelect(a, b) {
            // this.setMenu(b);
            // 跳转到指定位置
            this.$router.push(b.join("/"));
        }
    }
};
</script>

<style lang="scss" scoped>
.layout {
    height: 100%;
    background-color: #ecf0f5;

    .el-header {
        background-color: #fff;
    }

    .el-main {
        background-color: #ecf0f5;
    }

    .el-menu {
        height: 100%;
    }
}
</style>
